import { useContext } from 'react';
import { StoreContext, USER_DEFINED_STORE_ID_KEY } from './store-context';

/**
 * useStores()
 * Hook for accessing stores on context
 * @param storeClassNames
 * @returns
 */
export const useStores = storeClasses => {
  const {
    stores
  } = useContext(StoreContext);
  const foundStores = storeClasses.map(storeClass => {
    var _lazyInit, _ref;
    const storeClassName = storeClass[USER_DEFINED_STORE_ID_KEY];
    if (!storeClassName) {
      throw new Error(`class "${storeClass.name}" is missing static "${USER_DEFINED_STORE_ID_KEY}" property`);
    }
    let store = stores[storeClassName];
    let storeNotFound = false;
    if (!store) {
      // Attempt global fallback
      // This is an interop step that helps us migrate from Django website
      if (typeof globalThis['_STORES'] === 'object') {
        const globalStore = globalThis['_STORES'][storeClassName];
        if (globalStore) {
          store = globalStore;
        } else {
          storeNotFound = true;
        }
      } else {
        storeNotFound = true;
      }
      if (storeNotFound === true) {
        // Unable to locate store (or found in global scope)
        throw new Error(`Store "${storeClassName}" has not been registered with the StoreProvider`);
      }
    }
    // call lazy initialize if available on store
    (_lazyInit = (_ref = store).lazyInit) === null || _lazyInit === void 0 || _lazyInit.call(_ref);
    return store;
  });
  return foundStores;
};
//# sourceMappingURL=use-stores.js.map